import { surveyCheckResultContext } from ".";

export const SurveyCheckResultProvider = surveyCheckResultContext.Provider;